import { useRef } from "react";
import { motion, useInView } from "framer-motion";

/**
 * Kinetic letter-by-letter reveal (ciaoenergy-style).
 * Masks each word in overflow-hidden and springs letters up with a stagger.
 * `play` — when null, animates on scroll into view; pass a boolean to drive manually (hero).
 */
export const KineticWords = ({ text, className = "", charClassName = "", play = null, delay = 0 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const active = play === null ? inView : play;
  const words = text.split(" ");
  let i = 0;
  return (
    <span ref={ref} className={className} aria-label={text}>
      {words.map((w, wi) => (
        <span key={wi} className="inline-block overflow-hidden pb-1 align-bottom">
          <span className="inline-flex whitespace-pre">
            {w.split("").map((ch, ci) => {
              const d = delay + i++ * 0.026;
              return (
                <motion.span
                  key={ci}
                  className={`inline-block ${charClassName}`}
                  initial={false}
                  animate={active ? { y: 0, opacity: 1, rotate: 0 } : { y: "115%", opacity: 0, rotate: 6 }}
                  transition={{ type: "spring", stiffness: 320, damping: 17, delay: d }}
                  aria-hidden="true"
                >
                  {ch}
                </motion.span>
              );
            })}
          </span>
          {wi < words.length - 1 ? <span aria-hidden="true">&nbsp;</span> : null}
        </span>
      ))}
    </span>
  );
};
